// App.js
import { useEffect, useState } from "react";
// import "./App.css";
import "../etlsecound.css";
import hdfcs from '../../../../assets/images/banks/thermax.png';


function VRSManual() 
{
  

  return (
  <div style={{width:"100%"}}>
    <table className="table" >
    <tr className="fontcolor">
        <td colSpan={3}>Vendor Reconciliation Statement 1st April 2021 to 31st Mar 2022</td>
        
    </tr>
    <tr className="bold">
        <td colSpan={3}><img src={hdfcs} alt="" height="40px" width="60px" />THERMAX LIMITED &amp; Sagarbangha</td>
       
    </tr>
    <br></br>
    <tr className="fontcolor">
        <td>Si. No</td>
        <td>Particulars</td>
        <td> Amount </td>
    </tr>
   
    <tr>
        <td></td>
        <td>Balance as per Thermax</td>
        <td> 7,430,290.52 </td>
    </tr>
     
    <tr>
        <td></td>
        <td>Balance as per Vendor</td>
        <td> 2,837,666.84 </td>
    </tr>
     
    <tr>
        <td></td>
        <td>Variance</td>
        <td> 10,267,957.36 </td>
    </tr>
     
    <tr>
        <td></td>
        <td>Reasons for Variance</td>
        <td></td>
    </tr>
     
    <tr>
        <td>Annex1</td>
        <td>Purchase Invoices booked by Thermax not accounted by vendor</td>
        <td> -4,937,619.62 </td>
    </tr>
    
    <tr>
        <td>Annex2</td>
        <td>Sales considered by vendor but not accounted by Thermax</td>
        <td> 10,093,194.43 </td>
    </tr>
    
    <tr>
        <td>Annex3</td>
        <td>Payment received by vendor but not accounted by Thermax</td>
        <td></td>
    </tr>
    
    <tr>
        <td>Annex4</td>
        <td>Payment made by Thermax not accounted by vendor</td>
        <td> -   </td>
    </tr>
     
    <tr>
        <td>Annex5</td>
        <td>Debit Credit Note or any other difference</td>
        <td> 18,745.99 </td>
    </tr>
     
    <tr>
        <td>Annex 6 Opening Difference</td>
        <td></td>
        <td> 5,093,636.56 </td>
    </tr>
     
     
    <tr>
        <td></td>
        <td>Sum total of variance</td>
        <td> 10,267,957.36 </td>
    </tr>
     
    <tr>
        <td></td>
        <td>Check</td>
        <td> 0.00 </td>
    </tr>
     
    <tr>
        <td></td>
        <td>Reconciliation done till</td>
        <td>31st March 2022</td>
    </tr>
</table>
  </div>
  )
}



export default VRSManual;